import Show from '../show'

const ContractsDashboard = () => {
  return (
    <Show
      title="Contracts Dashboard"
      dashboardKey="ct_dashboards"
      showYear={true}
      showAnalytics={true}
    />
  )
}

export default ContractsDashboard
